import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LoginService} from '../inscription/services/login.service';
import {Router} from '@angular/router';
import {isMobile} from '@tensorflow/tfjs-core/dist/device_util';

@Component({
  selector: 'app-espace-entreprise',
  templateUrl: './espace-entreprise.component.html',
  styleUrls: ['./espace-entreprise.component.css']
})
export class EspaceEntrepriseComponent implements OnInit {
  currentLoginForm: 'assure' | 'entreprise' = 'assure';
  usernameassure = '';
  passwordassure = '';
  siretEntreprise = '';
  emailEntreprise = '';
  passwordEntreprise = '';
  identificationForm!: FormGroup;
  @ViewChild('assureForm') assureForm!: ElementRef;
  @ViewChild('entrepriseForm') entrepriseForm!: ElementRef;
  today: string = new Date().toISOString().split('T')[0];
  @Input() noBackground = false; // Input to toggle background


  constructor(private fb: FormBuilder,
              private loginService: LoginService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.identificationForm = this.fb.group({
      utilisateur: ['', Validators.required],
      motDePasse: ['', Validators.required],
    });
  }

  selectLoginForm(formType: 'assure' | 'entreprise'): void {
    this.currentLoginForm = formType;
    if (this.assureForm && this.entrepriseForm) {
      if (formType === 'assure') {
        this.assureForm.nativeElement.classList.add('active');
        this.entrepriseForm.nativeElement.classList.remove('active');
      } else {
        this.assureForm.nativeElement.classList.remove('active');
        this.entrepriseForm.nativeElement.classList.add('active');
      }
    }
  }

  handleLogin(event: Event, userType: 'assure' | 'entreprise'): void {
    event.preventDefault();
    if (userType === 'assure') {
      console.log('Connexion Assuré:',
          this.usernameassure,
          this.passwordassure
      );
    } else {
      console.log('Connexion Entreprise:', {
        siret: this.siretEntreprise,
        email: this.emailEntreprise,
        password: this.passwordEntreprise
      });
    }

    const submitBtn = event.target as HTMLButtonElement;
    submitBtn.textContent = 'Connexion en cours...';
    submitBtn.disabled = true;

    setTimeout(() => {
      submitBtn.textContent = 'Se connecter';
      submitBtn.disabled = false;
    }, 1500);
  }

  loginAssure(): void {
    this.identificationForm.patchValue({
      utilisateur: this.usernameassure,
      motDePasse: this.passwordassure
    });

    this.loginService.checkAssure(this.usernameassure, this.passwordassure)
        .subscribe({
          next: (res) => {
            console.log('Réponse backend:', res);
            if (res.retour === 1) {
              this.router.navigate(['auth/double-authentication', res]);
            }
          },
          error: (err) => {
            console.error('Erreur backend:', err);
          }
        });
  }


  protected readonly isMobile = isMobile;
}
